/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgMsgInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    viewBox="0 0 16 16"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.766 5.5c.699 0 1.265-.56 1.265-1.25S9.465 3 8.766 3c-.7 0-1.266.56-1.266 1.25S8.067 5.5 8.766 5.5Zm-2.41 7.287c.237.142.539.213.906.213.617 0 1.15-.129 1.6-.386A4.626 4.626 0 0 0 10 11.72l-.16-.12a5.293 5.293 0 0 1-.676.427 1.29 1.29 0 0 1-.533.12c-.237 0-.355-.098-.355-.293 0-.107.011-.214.035-.32a5.08 5.08 0 0 1 .107-.413L9.804 6.3l-.177-.12-3.343.72-.017.146.284.107c.45.15.622.408.516.772l-.836 2.997c-.06.222-.112.444-.16.666a2.804 2.804 0 0 0-.071.573c0 .275.119.484.356.626Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 14.8A6.8 6.8 0 1 0 8 1.2a6.8 6.8 0 0 0 0 13.6ZM8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z"
      clipRule="evenodd"
    />
  </svg>
)
const Memo = memo(SvgMsgInfo)
export default Memo
